const config = {
    locale: 'ru',
    baseUrl: 'http://195.38.162.132:8880/api/',
    siteTitle: 'GAUGI',
    noAvatarUrl: '/images/no-avatar.png',
    noImageUrl: '/images/no-image.png',
    isProduction: false,
    mode: 'local',
    moreData: '/json/data.php'
}

switch (location.hostname) {
    case '195.38.162.132':
        config.baseUrl = 'http://195.38.162.132:8880/api/'
        config.isProduction = false
        config.moreData = 'https://rent.page.kg/json/data.php'
        break
    case 'mammulk.gov.kg':
        config.baseUrl = 'https://mammulk.gov.kg/api/'
        config.isProduction = false
        config.moreData = 'https://rent.page.kg/json/data.php'
        break
    default:
        config.isProduction = false
        break
}
export default config

